import React, {Component} from 'react'
import {Switch} from 'react-router'
import ProtectedRoute from '../../panel-admin/common/helpers/ProtectedRoute'
import {
  PERMISSION_ARTICLES_READ,
  PERMISSION_ARTICLES_WRITE } from '../../constants'

import UserList from './UserList'
import UserEditForm from './UserEditForm'

class Users extends Component {
  render() {
    return (
      <Switch>
        <ProtectedRoute path={this.props.match.path} exact component={UserList} permission={PERMISSION_ARTICLES_READ} />
        <ProtectedRoute path={`${this.props.match.path}/add`} component={UserEditForm} permission={PERMISSION_ARTICLES_WRITE} />
        <ProtectedRoute path={`${this.props.match.path}/:id(\\d+)/edit`} component={UserEditForm} permission={PERMISSION_ARTICLES_WRITE} />
      </Switch>
    )
  }
}
export default Users
